import React from 'react';
import { motion } from 'framer-motion';
import { ArrowDownIcon } from 'lucide-react';
import { CaseSlideShell } from './CaseSlideShell';
import { nonTargetFunnel, nonTargetHeadlines, targetComparison } from '../../data/nordicCase';
export function CaseResults() {
  return <CaseSlideShell step="04" eyebrow="What happened? · Non-Target HCPs" surface headline={<>
          Non-target did not mean{' '}
          <span className="text-[var(--brand)]" data-id="element-136" data-mp="35o76tlbzo0aa">non-engaged.</span>
        </>} data-id="element-135" data-mp="27ydppj2a97iz">
      <div className="flex min-h-0 flex-1 gap-[clamp(0.8rem,1.6vw,1.5rem)]" data-id="element-137" data-mp="30nt9ax80k8qi">
        {/* Reach funnel — clearly separates distribution from engagement */}
        <motion.ol initial={{
        opacity: 0,
        x: -20
      }} animate={{
        opacity: 1,
        x: 0
      }} transition={{
        delay: 0.2,
        duration: 0.5
      }} aria-label="Non-Target reach, from email distribution to unique viewers" className="flex w-[34%] min-w-0 flex-shrink-0 flex-col justify-between" data-id="element-138" data-mp="2qxrhpvggc86u">
          {nonTargetFunnel.map((row, index) => <React.Fragment key={row.label} data-id="element-139" data-mp="321c6hl1y8jsa" data-mpi={index}>
              <li className={`flex items-center gap-[clamp(0.6rem,1vw,1rem)] rounded-xl px-[clamp(0.8rem,1.3vw,1.2rem)] py-[clamp(0.45rem,0.85vw,0.75rem)] ${index === 0 ? 'border-2 border-dashed border-[var(--fg)]/15 bg-transparent' : 'bg-white shadow-sm ring-1 ring-black/5'}`} data-id="element-140" data-mp="320akwmnb4ewb">
                <span className={`w-[4.5ch] flex-shrink-0 text-[clamp(1.3rem,2.3vw,2.2rem)] font-extrabold leading-none tracking-[-0.04em] tabular-nums ${index === 0 ? 'text-[var(--muted)]' : 'text-[var(--brand)]'}`} data-id="element-141" data-mp="2ieo0ac8nmof1">
                  {row.value}
                </span>
                <span className="min-w-0" data-id="element-142" data-mp="2knnqabcuxmc">
                  <span className="block text-[clamp(0.78rem,1.1vw,1.05rem)] font-bold leading-tight text-[var(--fg)]" data-id="element-143" data-mp="7kidgaje9h5t">
                    {row.label}
                  </span>
                  <span className="block text-[clamp(0.62rem,0.85vw,0.8rem)] leading-snug text-[var(--muted)]" data-id="element-144" data-mp="15kzviohp09z">
                    {row.detail}
                  </span>
                </span>
              </li>
              {index < nonTargetFunnel.length - 1 && <li className="flex justify-center" aria-hidden="true" data-id="element-145" data-mp="3nem7zp6wj78q">
                  <ArrowDownIcon className="h-[clamp(0.75rem,1vw,1rem)] w-[clamp(0.75rem,1vw,1rem)] text-[var(--brand)]/50" data-id="element-146" data-mp="oucipjg6w6a3" />
                </li>}
            </React.Fragment>)}
        </motion.ol>

        {/* Hero engagement metrics */}
        <div className="flex min-h-0 min-w-0 flex-1 flex-col gap-[clamp(0.5rem,1vw,0.9rem)]" data-id="element-147" data-mp="a6j2bwja4zqg">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.3,
          duration: 0.5
        }} className="flex min-h-0 flex-[1.4] flex-col justify-center rounded-2xl bg-[var(--brand)] px-[clamp(1.2rem,2.4vw,2.4rem)] py-[clamp(0.8rem,1.4vw,1.3rem)]" data-id="element-148" data-mp="17l3qwhofxqmw">
            <p className="text-[clamp(3.2rem,8vw,7.5rem)] font-extrabold leading-[0.9] tracking-[-0.06em] text-white" data-id="element-149" data-mp="1f5el373rlq6v">
              {nonTargetHeadlines.avgViewTime}
            </p>
            <p className="mt-2 text-[clamp(0.95rem,1.5vw,1.45rem)] font-bold text-white" data-id="element-150" data-mp="1p43ra2matm7a">
              Average view time
            </p>
            <p className="text-[clamp(0.7rem,0.95vw,0.9rem)] text-[var(--brand-lighter)]" data-id="element-151" data-mp="1u02ma924u2go">
              Time spent inside the Snak by those who played it
            </p>
          </motion.div>
          <div className="grid min-h-0 flex-1 grid-cols-2 gap-[clamp(0.5rem,1vw,0.9rem)]" data-id="element-152" data-mp="22v8ufeovkwmd">
            {[{
            value: nonTargetHeadlines.ctr,
            label: 'External CTR',
            detail: 'Users who clicked through to an external webpage'
          }, {
            value: nonTargetHeadlines.cueClicks,
            label: 'Cue interactions',
            detail: 'Clicks on interactive Cues inside the Snak'
          }].map((tile, index) => <motion.div key={tile.label} initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.42 + index * 0.08,
            duration: 0.5
          }} className="flex min-h-0 flex-col justify-center rounded-2xl bg-white px-[clamp(1rem,1.8vw,1.75rem)] py-[clamp(0.6rem,1.1vw,1rem)] shadow-sm ring-1 ring-black/5" data-id="element-153" data-mp="3egs18cesrf0z" data-mpi={index}>
                <p className="text-[clamp(2.2rem,4.6vw,4.4rem)] font-extrabold leading-none tracking-[-0.05em] text-[var(--brand)]" data-id="element-154" data-mp="2qlfl8dj7oyd8">
                  {tile.value}
                </p>
                <p className="mt-1 text-[clamp(0.85rem,1.25vw,1.2rem)] font-bold text-[var(--fg)]" data-id="element-155" data-mp="30jd74udlmj2o">
                  {tile.label}
                </p>
                <p className="text-[clamp(0.65rem,0.88vw,0.82rem)] leading-snug text-[var(--muted)]" data-id="element-156" data-mp="jteqv78nyhp2">
                  {tile.detail}
                </p>
              </motion.div>)}
          </div>
        </div>
      </div>

      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 0.7,
      duration: 0.5
    }} className="mt-[clamp(0.7rem,1.3vw,1.1rem)] flex flex-shrink-0 flex-wrap items-center justify-between gap-x-6 gap-y-1" data-id="element-157" data-mp="neq9vubnxo95">
        <p className="text-[clamp(0.72rem,1vw,0.95rem)] font-semibold text-[var(--fg)]" data-id="element-158" data-mp="ie2njlydpvl9">
          For reference, Target HCPs:{' '}
          <span className="font-extrabold" data-id="element-159" data-mp="165hj8vvnhenj">{targetComparison.avgViewTime}</span> average view time ·{' '}
          <span className="font-extrabold" data-id="element-160" data-mp="wdbr9m5eex8c">{targetComparison.ctr}</span> external CTR
        </p>
        <p className="max-w-xl text-[clamp(0.6rem,0.8vw,0.75rem)] leading-snug text-[var(--muted)]" data-id="element-161" data-mp="wbheiv4a6bfc">
          Engagement metrics reflect people who opened and played the Snak — not all 1,188 recipients. Descriptive results; no causality or statistical significance implied.
        </p>
      </motion.div>
    </CaseSlideShell>;
}